import { createSelector } from "reselect";

const customTableRowsState = (state) => state.customTableRows;

export const selectIsLoading = createSelector(customTableRowsState, (state) => state.all.loading);
export const selectError = createSelector(customTableRowsState, (state) => state.all.error);
export const selectAllCustomTableRows = createSelector(customTableRowsState, (state) => state.all.items);
